// @ts-ignore
import React, { useEffect } from "react";

import {
    AnalyticsEventPayload,
    useAnalyticsEvents
} from "@atlaskit/analytics-next";
import { DwellTimeHelperWithBrowserInteraction } from "@atlassiansox/analytics-web-client";

type Props = {
    eventData?: object;
    initialPollInterval?: number;
    nextPollIntervalCallback?: (x: number) => number;
    idleTimeout?: number;
    children: React.ReactNode;
};

export const DwellTimeWrapper = (props: Props) => {
    const {
        eventData,
        initialPollInterval,
        idleTimeout,
        nextPollIntervalCallback,
        children
    } = props;

    const { createAnalyticsEvent } = useAnalyticsEvents();

    useEffect(() => {
        const timer = new DwellTimeHelperWithBrowserInteraction(
            (payload: AnalyticsEventPayload) => {
                const flattenAttributes = { ...payload["attributes"] };
                delete payload["attributes"];

                createAnalyticsEvent({
                    ...flattenAttributes,
                    ...payload,
                    ...eventData
                }).fire();
            },
            eventData,
            null,
            {
                initialPollInterval,
                idleTimeout,
                multiplierCallback: nextPollIntervalCallback
            }
        );
        timer.start();

        return () => {
            timer.stop();
            timer.destroy();
        };
    }, []);

    return <>{children}</>;
};
